/**
 * VERSIONE LIBRERIA 3
 */

var CupparisAction = Class.extend({
    action : '',
    actionTitle: '',
    actionIcon: '',
    actionClass : '',
    defaultActionClass: '',
    prefixClass: '',
    actionText : '',
    func : null,
    type : null,
    visible : true,
    enabled : true,
    buttonClass : 'btn btn-default',
    control_type : 'button',
    target : null,
    func : function () {},
    init : function (params) {
        if (!params)
            params = {};
        if (!params.actionClass) {
            params.actionClass = this.defaultActionClass;
        }
        params.actionClass += ' ' + this.prefixClass + '-action-' + this.action;
        if (params.actionText)
            this.actionText = $.translate(params.actionText);
        //console.log('action params',params)
        // if (!params.actionTitle) {
        //     var title = '';
        //     if (params.actionIcon) {
        //         title += '<i class="'+ params.actionIcon +'"></i> ';
        //     }
        //     if (params.actionText) {
        //         title += params.actionIcon;
        //     }
        //     params.actionTitle = title;
        // }

        if (!params.actionTitle && !this.actionTitle) {
            params.actionTitle = this.actionText;
        }

        if (params) {
            for (var key in params) {
                this[key] = params[key];
            }
        }
    }
});
CupparisAction.factory = function (type,params) {

}
var RecordAction = CupparisAction.extend({
    defaultActionClass : 'btn btn-default btn-xs',
    prefixClass : 'record',
});

var CollectionAction = CupparisAction.extend({
    defaultActionClass : 'btn btn-primary btn-xs',
    prefixClass : 'collection',
});

var actionAddQueue = CupparisAction.extend({
    action : 'actionAddQueue',
    actionTitle : 'Accoda',
    actionIcon:  'fa fa-download',
    actionText : 'Accoda',
    queue: 'test',
    startMsg : null,
    waitMsg : 'Lavorazione in corso',
    successMsg : 'ok',
    queue_params : function () { return {}; },
    //target : '_blank',
    //control_type : 'link',

    func : function () {
        var self  = this;
        if (self.startMsg) {
            $.confirmDialog(self.startMsg).ok(function () {
                self._addQueue(self.queue, self.queue_params());
            });
        } else {
            self._addQueue(self.queue,self.queue_params());
        }
    },

    _addQueue : function (queue,params) {
        var self = this;
        var r = Routes.addQueue;
        r.method(Routes.getUrlInstance('addQueue',{'queue':queue}),params,function (json) {
            console.log('json');
            if (json.error ) {
                $.errorDialog(json.msg);
                return ;
            }
            $.waitStart(self.waitMsg);
            self._waitQueue(json.jobId, function(json) {
                self._addQueueCallback(json);
            });
        });
    },
    _addQueueCallback : function (json) {
        var self = this;
        if (json.error) {
            $.errorDialog(json.msg);
            return ;
        }
        if (json.job.error) {
            $.errorDialog(json.error.msg);
            return ;
        }
        $.messageDialog(self.successMsg);
    },
    _waitQueue : function (jobId,callback) {
        var self =  this;
        var r = Routes.queueStatus;
        r.method(Routes.getUrlInstance('queueStatus',{'jobId':jobId}),function (json) {
            console.log('json');
            try {
                if (json.error) {
                    $.waitEnd();
                    if (callback) {
                        callback(json);
                    } else {
                        $.errorDialog(json.msg);
                    }
                    return ;
                }
                if (json.job.end) {
                    $.waitEnd();
                    if (callback) {
                        callback(json);
                    } else {
                        if (json.job.error) {
                            $.errorDialog(json.job.msg);
                        }
                    }
                    return ;
                }

                setTimeout(function () {
                    self._waitQueue(jobId,callback);
                },2000);
            } catch (e) {
                $.waitEnd();
                if (callback) {
                    callback({error:1,msg:e.message});
                } else {
                    $.errorDialog(e.message);
                }
                return ;
            }
            return ;


        })
    }
});

var actionAddQueueRecord = RecordAction.extend({
    action : 'actionAddQueue',
    actionTitle : $.translate('general-accoda'),
    actionIcon:  'fa fa-download',
    actionText : $.translate('general-accoda'),
    queue: 'test',
    startMsg : null,
    waitMsg : 'Lavorazione in corso',
    successMsg : 'ok',
    queue_params : function () { return {}; },
    //target : '_blank',
    //control_type : 'link',

    func : actionAddQueue.prototype.func,
    _addQueue : actionAddQueue.prototype._addQueue,
    _addQueueCallback : actionAddQueue.prototype._addQueueCallback,
    _waitQueue : actionAddQueue.prototype._waitQueue,
});
var actionAddQueueCollection = CollectionAction.extend({
    action : 'actionAddQueue',
    actionTitle : 'Accoda',
    actionIcon:  'fa fa-download',
    actionText : 'Accoda',
    queue: 'test',
    startMsg : null,
    waitMsg : 'Lavorazione in corso',
    successMsg : 'ok',
    queue_params : function () { return {}; },
    //target : '_blank',
    //control_type : 'link',

    func : actionAddQueue.prototype.func,
    _addQueue : actionAddQueue.prototype._addQueue,
    _addQueueCallback : actionAddQueue.prototype._addQueueCallback,
    _waitQueue : actionAddQueue.prototype._waitQueue,


});

var actionCsvDownloadQueueCollection = actionAddQueueCollection.extend({
    action : 'actionCsvDownloadQueueCollection',
    actionTitle : 'Accoda Csv Download',
    actionIcon:  'fa fa-download',
    actionText : 'Csv',
    csvType : null,
    queue : 'csv_export',
    waitMsg : 'Generazione del file in corso',
    callbackRoute : '/downloadtemp/',
    queue_params : function () {
        var config = Facade.controller.getViewConfig(this.view.keyId);
        var params = _.clone(config.query_params);
        params.model = this.view.modelName;
        if (this.csvType)
            params.csvType = this.csvType;
        if (this.view.config.constraintKey) {
            params.constraintKey = this.view.config.constraintKey;
            params.constraintValue = this.view.config.constraintValue;

        }
        return params;
    },
    _addQueueCallback : function (json) {
        var self = this;
        console.log('adddqueued',json, self);
        var output_data = JSON.parse(json.job.output_data);
        var downloadUrl = self.callbackRoute + output_data.filename;
        //var downloadUrl = '/downloadtemp/' + output_data.filename;
        // $.messageDialog('Route download: ' + downloadUrl);
        document.location.href = downloadUrl;
    },

});

var actionPdfDownloadQueueCollection = actionAddQueueCollection.extend({
    action : 'actionPdfDownloadQueueCollection',
    actionTitle : 'Accoda Pdf Download',
    actionIcon:  'fa fa-download',
    actionText : 'Pdf',
    pdfType : 'list',
    queue : 'pdf_export',
    waitMsg : 'Generazione del file in corso',
    callbackRoute : '/downloadtemp/',
    queue_params : function () {
        var config = Facade.controller.getViewConfig(this.view.keyId);
        var params = _.clone(config.query_params);
        params.model = this.view.modelName;
        if (this.pdfType)
            params.pdfType = this.pdfType;
        if (this.view.config.constraintKey) {
            params.constraintKey = this.view.config.constraintKey;
            params.constraintValue = this.view.config.constraintValue;
        }
        return params;
    },
    _addQueueCallback : function (json) {
        var self = this;
        console.log('adddqueued',json, self);
        var output_data = JSON.parse(json.job.output_data);
        var downloadUrl = self.callbackRoute + output_data.filename;
        //var downloadUrl = '/downloadtemp/' + output_data.filename;
        // $.messageDialog('Route download: ' + downloadUrl);
        document.location.href = downloadUrl;
    },

});

var actionPdfDownloadQueueRecord = actionAddQueueRecord.extend({
    action : 'actionPdfDownloadQueueRecord',
    actionTitle : 'Accoda Pdf Download',
    actionIcon:  'fa fa-download',
    actionText : 'Pdf',
    pdfType : 'record',
    queue : 'pdf_export',
    waitMsg : 'Generazione del file in corso',
    callbackRoute : '/downloadtemp/',
    func : function (id) {
        var self  = this;
        var params = self.queue_params();
        params.id = id;
        self._addQueue(self.queue,params);
    },
    queue_params : function () {
        var config = Facade.controller.getViewConfig(this.view.keyId);
        var params = _.clone(config.query_params);
        params.model = this.view.modelName;
        if (this.pdfType)
            params.pdfType = this.pdfType;
        return params;
    },
    _addQueueCallback : function (json) {
        var self = this;
        console.log('adddqueued',json, self);
        var output_data = JSON.parse(json.job.output_data);
        var downloadUrl = self.callbackRoute + output_data.filename;
        //var downloadUrl = '/downloadtemp/' + output_data.filename;
        //  $.messageDialog('Route download: ' + downloadUrl);
        document.location.href = downloadUrl;
    },

});

var defaultSingleActions = {
    actionDelete : new RecordAction({
        action : 'actionDelete',
        actionTitle : 'Cancella',
        actionIcon:  'fa fa-remove text-danger',
        actionClass :null,
        actionText : '',
    }),
    actionView : new RecordAction({
        action : 'actionView',
        actionTitle :'Visualizza',
        actionIcon:  'fa fa-list-alt',
        actionClass :null,
        actionText : '',
    }),
    actionEdit: new RecordAction({
        action : 'actionEdit',
        actionTitle : 'Modifica',
        actionIcon:  'fa fa-edit',
        actionClass :null,
        actionText : '',
    }),
    actionSave : new RecordAction({
        action : 'actionSave',
        actionTitle : 'Salva',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Salva',
    }),
    actionCancel : new RecordAction({
        action : 'actionCancel',
        actionTitle : 'Annulla',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Annulla',
    }),
    actionSearch : new RecordAction({
        action : 'actionSearch',
        actionTitle : 'Ricerca',
        actionIcon:  'fa fa-search',
        actionClass : 'btn btn-xs btn-default text-info',
        actionText : 'Cerca',
    }),
    actionReset : new RecordAction({
        action : 'actionReset',
        actionTitle : 'Annulla filtri ricerca',
        actionIcon:  '',
        actionClass : 'btn btn-xs btn-default',
        actionText : 'Annulla filtri',
    }),
    actionAddCsv : new RecordAction({
        action : 'actionAddCsv',
        actionTitle : 'Carica i dati del file',
        actionIcon:  'fa fa-upload ',
        actionClass :null,
        actionText : 'Carica file',
    }),
    actionRecuperaCsv : new RecordAction({
        action : 'actionRecuperaCsv',
        actionTitle : 'Recupera caricamento precedente',
        actionIcon:  'fa fa-folder ',
        actionClass :null,
        actionText : 'Recupera caricamento precedente',
    }),
    actionSaveCsv : new RecordAction({
        action : 'actionSaveCsv',
        actionTitle : 'Salva dati',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Salva dati',
    }),
    actionCsvCancel : new RecordAction({
        action : 'actionCsvCancel',
        actionTitle : '',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Annulla',
    }),
    actionCsvDownloadRecord : new RecordAction({
        action : 'actionCsvDownloadRecord',
        actionTitle : 'Scarica Csv',
        actionIcon:  '',
        actionClass :null,
        actionText : 'downloadCsv',
        target : '_blank',
        control_type : 'link',
        func : function (id) {
            var config = Facade.controller.getViewConfig(this.keyId);

            return '/download/csv/' + this.modelName + '?' + $.param(config.query_params);
        }
    }),
    actionPdfDownloadRecord : new RecordAction({
        action : 'actionPdfDownloadRecord',
        actionTitle : 'Scarica Pdf',
        actionIcon:  'fa fa-file-pdf-o',
        actionClass :null,
        actionText : '',
        pdfType : 'record',
        target : '_blank',
        control_type : 'link',
        func : function (id) {
            var config = Facade.controller.getViewConfig(this.keyId);

            return '/download/pdf/' + this.modelName + '/' + this.pdfType + '?' + $.param(config.query_params);
        }
    }),

    actionBack : new RecordAction({
        action : 'actionBack',
        actionTitle : 'Indietro',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Torna indietro',
    }),

    actionSaveBack : new RecordAction({
        action : 'actionSaveBack',
        actionTitle : 'Salve e torna pagina precedente',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Salva e torna indietro',
    })
};

var defaultGlobalActions = {
    actionDeleteAll: new CollectionAction({
        action : 'actionDeleteAll',
        actionTitle : 'Cancella selezionati',
        actionIcon:  'fa fa-trash text-danger',
        actionClass : 'btn btn-default btn-xs text-danger',
        actionText : 'Selezionati',
        needSelection : true,
    }),
    actionInsert: new CollectionAction({
        action : 'actionInsert',
        actionTitle : 'Inserisci',
        actionIcon:  'fa fa-plus text-success',
        actionClass :'btn btn-default btn-xs text-success',
        actionText : 'Nuovo',
    }),
    actionCsvShowAll : new CollectionAction({
        action : 'actionCsvShowAll',
        actionTitle : 'Mostra tutte le righe',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Mostra tutto',
    }),
    actionCsvShowError : new CollectionAction({
        action : 'actionCsvShowError',
        actionTitle : 'Mostra solo errori',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Mostra solo errori',
    }),
    actionCsvRevalidate : new CollectionAction({
        action : 'actionCsvRevalidate',
        actionTitle : 'Rivalida csv caricato',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Rivalida csv',
    }),
    actionBack : new CollectionAction({
        action : 'actionBack',
        actionTitle : 'Indietro',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Torna indietro',
    }),
    actionReload : new CollectionAction({
        action : 'actionReload',
        actionTitle : 'Ricarica',
        actionIcon:  '',
        actionClass :null,
        actionText : 'Reload',
    }),
    actionCsvDownloadCollection : new CollectionAction({
        action : 'actionCsvDownloadCollection',
        actionTitle : 'Scarica Csv',
        actionIcon:  'fa fa-download',
        actionClass :null,
        actionText : 'Csv',
        target : '_blank',
        control_type : 'link',
        func : function () {
            var config = Facade.controller.getViewConfig(this.view.keyId);
            return '/download/csv/' + this.view.modelName + '?' + $.param(config.query_params);
        }
    }),
    actionPdfDownloadCollection : new CollectionAction({
        action : 'actionPdfDownloadCollection',
        actionTitle : 'Scarica Pdf',
        actionIcon:  'fa fa-download',
        actionClass :null,
        actionText : 'Pdf',
        target : '_blank',
        control_type : 'link',
        func : function () {
            var config = Facade.controller.getViewConfig(this.view.keyId);
            return '/download/csv/' + this.view.modelName + '?' + $.param(config.query_params);
        }
    }),
    actionPdfDownloadQueueCollection : new CollectionAction({
        action : 'actionPdfDownloadQueueCollection',
        actionTitle : 'Accoda Pdf Download',
        actionIcon:  'fa fa-download',
        actionClass :null,
        actionText : 'Pdf',
        target : '_blank',
        control_type : 'link',
        func : function () {
            var config = Facade.controller.getViewConfig(this.view.keyId);
            return '/queue/add/pdf_export' + '?model=' +this.view.modelName + '&' +$.param(config.query_params);
        }
    }),
    actionCsvDownloadCollectionQueue :new CollectionAction({
        action: 'actionCsvDownloadCollectionQueue',
        actionTitle: 'Accoda Csv Download',
        actionIcon: 'fa fa-download',
        actionClass: null,
        actionText: 'Csv',
        target: '_blank',
        control_type: 'link',
        func: function () {
            var config = Facade.controller.getViewConfig(this.view.keyId);
            return '/queue/add/csv_export' + '?model=' + this.view.modelName + '&' + $.param(config.query_params);
        }
    })
};


// azioni di utilita' generali del core ma non istanziate nel controller.
var actionSend = new RecordAction({
    action : 'actionSend',
    //icon : 'fa-send',
    actionIcon : 'fa fa-envelope-o',
    actionTitle : 'Spedisci',
    func : function (id,subject_it) {
        log.info('spedisco newsletter ' + id + " : " + subject_it);
        var controller = this._controller;
        var vListKey = this.keyId;
        var tpl_values = {
            subject_it:subject_it,
            sends_type :{'all':'Tutti gli iscritti','users':'Solo gli utenti iscritti','newsletter_email':'Solo agli iscritti non utenti'}
        };

        $.renderJson('#sendnewsletter_dialog','#sendnewsletter_dialog',tpl_values);
        $('#sendnewsletter_dialog').modal('show').ok(function () {
            var type = $('#sendnewsletter_dialog select[name="type"]').val();

            $.get(Facade.getUrl('/queue/add/newsletter/send'),{newsletter_id:id,type:type},function (json) {
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }

            }).fail(function (e) {
                $.errorDialog($.getFailMessage(e));
            });
        });
    }
});


var actionSendAll = new RecordAction({
    action : 'actionSendAll',
    actionIcon : 'fa fa-send',
    // actionClass : 'btn-primary',
    actionText : 'Salva e Spedisci a tutti',
    func : function (id,subject_it) {
        var _controller = this; // oggetto chiamante qui sempre il controller
        $.progressDialog("Salvataggio in corso...", 1);
        var controller = this._controller;
        var vKey = this.keyId;
        controller.save(vKey,null,null,function (json){
       // _controller._save(function (json) {
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            $.progressDialog("Invio newsletter ...", 50);
            $.get(Facade.getUrl('/queue/add/newsletter/send'),{newsletter_id:id,type:'all'},function (json) {
                $.progressDialogClose();
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }

                $.messageDialog("Salvataggio e invio avvenuto con successo");
            }).fail(function (e) {
                $.progressDialogClose();
                $.errorDialog($.getFailMessage(e));
            })
        });

    }
});

var actionSendUsers = new RecordAction({
    action : 'actionSendUsers',
    actionIcon : 'fa fa-send',
    actionText : 'Salva e Spedisci agli utenti',
    func : function (id,subject_it) {
        alert('id ' + id);
    }
});